module.exports = __webpack_public_path__ + "img/logo-melvid.5b6ad4c1.png";